// Generated by CoffeeScript 1.12.7
(function () {
  var AccountAnalytics, FeatureFlag;

  FeatureFlag = require("@CommonFrontendBackend/FeatureFlag").FeatureFlag;

  module.exports = AccountAnalytics = (function () {
    function AccountAnalytics(
      di,
      make,
      createUi,
      usingFeature,
      upseller,
      AccountEventData,
      EntityData,
      account,
      integrationService,
    ) {
      var basicAnalytics, entityData, eventData, fullAnalytics;
      eventData = make(AccountEventData);
      di.value("eventData", eventData);
      entityData = make(EntityData, {
        accountId: account._id,
      });
      di.value("entityData", entityData);
      basicAnalytics = usingFeature(FeatureFlag.BasicAnalytics);
      fullAnalytics = usingFeature(FeatureFlag.FullAnalytics);
      this.ui = createUi(require("Analytics/Account/Account.html"), {
        basicAnalytics: basicAnalytics,
        fullAnalytics: fullAnalytics,
        showIntegrationMarketer: false,
        $init: function () {
          if (!basicAnalytics && !fullAnalytics) {
            return upseller.upsell({
              feature: "basic analytics",
              featureLabel: "Analytics",
            });
          }
        },
      });
      if (basicAnalytics) {
        this.ui.projects = make(require("../Visualizations/Projects/Projects"), {
          onLoad: (function (_this) {
            return function () {
              if (!integrationService.usingAnalyticsIntegration()) {
                return (_this.ui.showIntegrationMarketer = true);
              }
            };
          })(this),
        });
      }
      if (fullAnalytics) {
        this.ui.quotes = make(require("../Visualizations/Quotes/Quotes"));
        this.ui.views = make(require("../Visualizations/Views/Views").ViewsVisualization, {
          options: {
            showProjectName: true,
          },
        });
      }
    }

    return AccountAnalytics;
  })();
}.call(this));
